const getArraySorter = function (fieldName, isAsc) {
  let func = function (a, b) {
    if (a[fieldName] > b[fieldName]) return (isAsc ? 1 : -1)
    if (b[fieldName] > a[fieldName]) return (isAsc ? -1 : 1)

    return 0
  }
  return func
}

const isArrayEmptyOrNull = function (arr) {
  return !(Array.isArray(arr) && arr.length)
}

const removeDuplicates = function (arr) {
  return arr.filter((item, index) => arr.indexOf(item) === index)
}

export default { getArraySorter, isArrayEmptyOrNull, removeDuplicates }

export { getArraySorter, isArrayEmptyOrNull, removeDuplicates }
